import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import BadgingTabs from '../../components/BadgingTabs';
import StandistesTab from '../../components/StandistesTab';
import StaffBadgesTab from '../../components/StaffBadgesTab';
import Contractor from '../../components/Contractor';
import BadgingSettings from '../../components/BadgingSettings';
import { MdOutlineBadge } from 'react-icons/md';
import BadgesHistory from '../../components/BadgesHistory';
import { getSessionUser } from "../../utils/session";

const Badging = () => {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState('standistes');
  const sessionUser = getSessionUser();
  const isSubAdmin = sessionUser.role === "sub_admin";

  return (
    <div className='p-6'>
      <div className="mb-8">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-4">
            <div className="p-2 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl shadow-lg shadow-violet-500/30">
              <MdOutlineBadge className="w-6 h-6 text-white" />
            </div>

            <div>
              <h1 className="text-lg font-bold text-slate-900">
                Badging & Accreditation
              </h1>
              <p className="text-slate-600 text-xs">
                Manage standistes, badges, and access control for this event
              </p>
            </div>
          </div>
        </div>
      </div>

      <BadgingTabs
        activeTab={activeTab}
        isSubAdmin={isSubAdmin}
        setActiveTab={setActiveTab}
      />

      {activeTab === 'standistes' && (
        <StandistesTab eventId={id} isSubAdmin={isSubAdmin} />
      )}

      {activeTab === 'contractor' && (
        <Contractor eventId={id} isSubAdmin={isSubAdmin} />
      )}

      {activeTab === 'staff' && (
        <StaffBadgesTab eventId={id} isSubAdmin={isSubAdmin} />
      )}

      {activeTab === 'history' && (
        <BadgesHistory eventId={id} isSubAdmin={isSubAdmin} />
      )}

      {activeTab === 'settings' && (
        <BadgingSettings eventId={id} />
      )}

    </div>
  );
};

export default Badging;
